import { useAuthStore } from "@/stores/authStore";

const API_BASE_URL =
  (import.meta.env.VITE_GATEWAY_API_URL as string | undefined)?.replace(/\/+$/, "") ||
  "http://localhost:8000";

export { API_BASE_URL };

export async function fetchWithInterceptor(
  input: RequestInfo | URL,
  init?: RequestInit
): Promise<Response> {
  const response = await fetch(input, init);

  if (response.status === 401) {
    useAuthStore.getState().signOut();
    throw new Error("Session expired. You have been logged out.");
  }

  return response;
}
